import React from "react";
import { MoreHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "./Button";
import { CaseLink } from "@/components/CaseLink";
import { StageChip } from "./chips";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// 40px single line: HL-ID · name · stage · reason (status text) · quote · primary action · ⋯ menu · age
export function TriageRow({ caseId, recordId, name, stage, reason, quote, action, onAction, menu = [], age, selected = false, done = false, onOpen, className, testid }) {
  return (
    <li data-testid={testid || `triage-${caseId}`} onDoubleClick={onOpen}
      className={cn("group flex items-center gap-3 h-row-lg px-3 border-b border-hairline font-ui text-ui-sm transition-all duration-150 hover:bg-muted", selected && "bg-accent shadow-[inset_2px_0_0_hsl(var(--primary))]", done && "h-0 opacity-0 overflow-hidden border-0", className)}>
      {recordId ? <CaseLink recordId={recordId} className="font-display font-medium text-primary text-ui-xs w-[64px] text-left flex-shrink-0 hover:underline">{caseId}</CaseLink> : <button onClick={onOpen} className="font-display font-medium text-primary text-ui-xs w-[64px] text-left flex-shrink-0 hover:underline">{caseId}</button>}
      <span className="text-foreground truncate max-w-[180px] flex-shrink-0">{name}</span>
      {stage && <StageChip stage={stage} size="sm" short />}
      <span className="flex-shrink-0">{reason}</span>
      {quote && <span className="text-muted-foreground truncate italic">“{quote}”</span>}
      <span className="flex-1" />
      {action && <Button size="sm" variant={selected ? "primary" : "secondary"} onClick={onAction} data-testid={testid && `${testid}-action`}>{action}</Button>}
      {menu.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild><Button size="icon" variant="ghost" label="More" icon={MoreHorizontal} className="opacity-0 group-hover:opacity-100 focus:opacity-100" /></DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="rounded-card shadow-popover text-ui-sm">{menu.map((m) => <DropdownMenuItem key={m.label} onClick={m.onClick}>{m.label}</DropdownMenuItem>)}</DropdownMenuContent>
        </DropdownMenu>
      )}
      {age && <span className="text-ui-xs text-muted-foreground w-8 text-right flex-shrink-0">{age}</span>}
    </li>
  );
}
